export default "__VITE_ASSET__CRyIfDC4__";